import { render, staticRenderFns } from "./form-date.vue?vue&type=template&id=0fbef8c8&scoped=true"
import script from "./form-date.vue?vue&type=script&lang=js"
export * from "./form-date.vue?vue&type=script&lang=js"
import style0 from "./form-date.vue?vue&type=style&index=0&id=0fbef8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbef8c8",
  null
  
)

export default component.exports